import React from 'react'
import { Button, Form, Input, TextArea, Modal } from 'semantic-ui-react'
import $ from 'jquery'

export default class AboutYou extends React.Component {
  constructor(props) {
    super(props)
    this.submitFeedback = this.submitFeedback.bind(this)
  }

  submitFeedback() {
    const name = $("#name").val()
    const organization = $("#organization").val()
    const email = $("#email").val()
    const about = $("#about").val()

    if (!name || !email){
      alert("You must specify name and email.")
      return false
    }

    $.post(this.props.root + '/feedbacks', {
      name,
      email,
      about,
      organization
    })

    console.log('AJAX request to the Rails server')
    this.props.markFeedbackSubmitted()
  }

  render() {
    return (
      <Modal size="fullscreen" open={this.props.visible}>
        <Modal.Header>Tell Us About Yourself</Modal.Header>
        <Modal.Content>
          <p>
            We're excited to see that you've been using our validator. We intend to continue
            offering this as a free product, but would like to know who you are and what changes and
            features you would like to see. Also feel free to reach out directly to me at
            rodney@arcticdataservices.com. Thanks!
          </p>

          <Form>
            <Form.Group widths="equal">
              <Form.Field control={Input} label="Name" placeholder="Full Name" id="name"/>
              <Form.Field control={Input} label="Organization" placeholder="Organization" id="organization"/>
              <Form.Field control={Input} label="Email" placeholder="something@example.com" id="email"/>
            </Form.Group>
            <Form.Field
              id="about"
              control={TextArea}
              label="About"
              placeholder="How you're using the validator and what features you'd like to see..."
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            icon="checkmark"
            labelPosition="right"
            content="Submit"
            onClick={this.submitFeedback}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}
